exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs-ul[data-v-e95a436c]{list-style:none;display:flex;padding:0;margin:0;background:var(--wf-secondary);border-radius:5px;overflow:hidden;li{display:flex;align-items:center;padding:0 0 10px;text-decoration:none;text-transform:uppercase;color:var(--wf-primary);font-size:13px;&.breadcrumbs-icon{&:after{margin:0 5px;font-family:Font Awesome\\ 6 Free;font-weight:900;content:\"\\F054\"}}&.goto-parent-link{&:hover{font-weight:700;cursor:pointer;color:var(--db-sidebar-ul-li-a-active-bg)}}}}", ""]);

// exports
